import React from 'react';
import { GoogleMap, LoadScript, Marker  } from '@react-google-maps/api';

const UslMap = () => {
    const mapStyles = {
      height: '350px',
      width:'100%'
    };
    const defaultCenter = {
      lat: 23.85179654129123,  // Latitude
      lng: 90.40585021485455   // Longitude
    };
  return (
    <LoadScript googleMapsApiKey="AIzaSyD4c4k_KvT6rwl5M8O6m4XTdRTydDUVE8Q">
        <GoogleMap mapContainerStyle={mapStyles} zoom={17} center={defaultCenter}/>
        <Marker position={defaultCenter} />
    </LoadScript>
  )
}

export default UslMap